import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftCredentialServer } from "namirasoft-credential";
import { NamirasoftInfraServer } from "namirasoft-infra";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { InfraLayout } from "./InfraLayout";
import { InfraRoutes } from "./InfraRoutes";
import AlertEditPage from "./pages/AlertEditPage";
import AlertListPage from "./pages/AlertListPage";
import AlertViewPage from "./pages/AlertViewPage";
import CacheEditPage from "./pages/CacheEditPage";
import CacheListPage from "./pages/CacheListPage";
import CacheViewPage from "./pages/CacheViewPage";
import CloudEditPage from "./pages/CloudEditPage";
import CloudListPage from "./pages/CloudListPage";
import CloudViewPage from "./pages/CloudViewPage";
import ContainerEditPage from "./pages/ContainerEditPage";
import ContainerListPage from "./pages/ContainerListPage";
import ContainerViewPage from "./pages/ContainerViewPage";
import DatabaseEditPage from "./pages/DatabaseEditPage";
import DatabaseListPage from "./pages/DatabaseListPage";
import DatabaseViewPage from "./pages/DatabaseViewPage";
import EnvironmentEditPage from "./pages/EnvironmentEditPage";
import EnvironmentListPage from "./pages/EnvironmentListPage";
import EnvironmentSelectPage from "./pages/EnvironmentSelectPage";
import EnvironmentViewPage from "./pages/EnvironmentViewPage";
import HomePage from "./pages/HomePage";
import IncidentListPage from "./pages/IncidentListPage";
import IncidentViewPage from "./pages/IncidentViewPage";
import KubernetesEditPage from "./pages/KubernetesEditPage";
import KubernetesListPage from "./pages/KubernetesListPage";
import KubernetesViewPage from "./pages/KubernetesViewPage";
import LoginPage from "./pages/LoginPage";
import MessagingEditPage from "./pages/MessagingEditPage";
import MessagingListPage from "./pages/MessagingListPage";
import MessagingViewPage from "./pages/MessagingViewPage";
import MetricEditPage from "./pages/MetricEditPage";
import MetricListPage from "./pages/MetricListPage";
import MetricViewPage from "./pages/MetricViewPage";
import MonitorEditPage from "./pages/MonitorEditPage";
import MonitorListPage from "./pages/MonitorListPage";
import MonitorViewPage from "./pages/MonitorViewPage";
import ProjectDiagramPage from "./pages/ProjectDiagramPage";
import ProjectEditPage from "./pages/ProjectEditPage";
import ProjectListPage from "./pages/ProjectListPage";
import ProjectViewPage from "./pages/ProjectViewPage";
import ServerEditPage from "./pages/ServerEditPage";
import ServerListPage from "./pages/ServerListPage";
import ServerViewPage from "./pages/ServerViewPage";
import StreamingEditPage from "./pages/StreamingEditPage";
import StreamingListPage from "./pages/StreamingListPage";
import StreamingViewPage from "./pages/StreamingViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_INFRA}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_CREDENTIAL = new EnvService("REACT_APP_BASE_URL_CREDENTIAL", true).getString();
            let REACT_APP_BASE_URL_INFRA = new EnvService("REACT_APP_BASE_URL_INFRA", true).getString();

            let credential = new NamirasoftCredentialServer(REACT_APP_BASE_URL_CREDENTIAL, result.account.token_manager, result.notifier.onError);
            let infra = new NamirasoftInfraServer(REACT_APP_BASE_URL_INFRA, result.account.token_manager, result.notifier.onError);

            let servers = { credential, infra };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={InfraRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={InfraRoutes.AlertList} element={<AlertListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.AlertNew} element={<AlertEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.AlertView(":id")} element={<AlertViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.AlertEdit(":id")} element={<AlertEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.AlertCopy(":id")} element={<AlertEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.CacheList} element={<CacheListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.CacheNew} element={<CacheEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.CacheView(":id")} element={<CacheViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.CacheEdit(":id")} element={<CacheEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.CacheCopy(":id")} element={<CacheEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.CloudList} element={<CloudListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.CloudNew} element={<CloudEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.CloudView(":id")} element={<CloudViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.CloudEdit(":id")} element={<CloudEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.CloudCopy(":id")} element={<CloudEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.DatabaseList} element={<DatabaseListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.DatabaseNew} element={<DatabaseEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.DatabaseView(":id")} element={<DatabaseViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.DatabaseEdit(":id")} element={<DatabaseEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.DatabaseCopy(":id")} element={<DatabaseEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.ContainerList} element={<ContainerListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ContainerNew} element={<ContainerEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.ContainerView(":id")} element={<ContainerViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ContainerEdit(":id")} element={<ContainerEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.ContainerCopy(":id")} element={<ContainerEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.EnvironmentList} element={<EnvironmentListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.EnvironmentNew} element={<EnvironmentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.EnvironmentView(":id")} element={<EnvironmentViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.EnvironmentEdit(":id")} element={<EnvironmentEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.EnvironmentCopy(":id")} element={<EnvironmentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.EnvironmentSelect(":project-id")} element={<EnvironmentSelectPage {...result} servers={servers} />} />

                            <Route path={InfraRoutes.IncidentList} element={<IncidentListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.IncidentView(":id")} element={<IncidentViewPage {...result} servers={servers} />} />

                            <Route path={InfraRoutes.KubernetesList} element={<KubernetesListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.KubernetesNew} element={<KubernetesEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.KubernetesView(":id")} element={<KubernetesViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.KubernetesEdit(":id")} element={<KubernetesEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.KubernetesCopy(":id")} element={<KubernetesEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.MessagingList} element={<MessagingListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MessagingNew} element={<MessagingEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.MessagingView(":id")} element={<MessagingViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MessagingEdit(":id")} element={<MessagingEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.MessagingCopy(":id")} element={<MessagingEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.MetricList} element={<MetricListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MetricNew} element={<MetricEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.MetricView(":id")} element={<MetricViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MetricEdit(":id")} element={<MetricEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.MetricCopy(":id")} element={<MetricEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.MonitorList} element={<MonitorListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MonitorNew} element={<MonitorEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.MonitorView(":id")} element={<MonitorViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.MonitorEdit(":id")} element={<MonitorEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.MonitorCopy(":id")} element={<MonitorEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.ProjectList} element={<ProjectListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ProjectNew} element={<ProjectEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.ProjectView(":id")} element={<ProjectViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ProjectEdit(":id")} element={<ProjectEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.ProjectCopy(":id")} element={<ProjectEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.ProjectDiagram(":project-id", ":environment-id")} element={<ProjectDiagramPage {...result} servers={servers} />} />

                            <Route path={InfraRoutes.ServerList} element={<ServerListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ServerNew} element={<ServerEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.ServerView(":id")} element={<ServerViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.ServerEdit(":id")} element={<ServerEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.ServerCopy(":id")} element={<ServerEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={InfraRoutes.StreamingList} element={<StreamingListPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.StreamingNew} element={<StreamingEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={InfraRoutes.StreamingView(":id")} element={<StreamingViewPage {...result} servers={servers} />} />
                            <Route path={InfraRoutes.StreamingEdit(":id")} element={<StreamingEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={InfraRoutes.StreamingCopy(":id")} element={<StreamingEditPage {...result} servers={servers} isEdit={false} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={InfraRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <InfraLayout {...props}>
                {props.children}
            </InfraLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;